const environments = {
  local: "gestor_eventos",
  dev_server: "gestor_eventos",
  prod_server: "",
};

const environmentsRoots = {
  local: "",
  dev_server: "",
  prod_server: "",
};

const environment = process.env.REACT_APP_ADM_ENV;
const environmentR = process.env.REACT_APP_ROUTES;
const eventRoot = process.env.REACT_APP_EVENT_ROUTES

const urlRoot = environments[environment];
const urlRoute = environmentsRoots[environmentR];

const protocolo = window.location.protocol; //http
//const serv = window.location.hostname; //localhost
var rootGestor = "calendario.tec.mx/";
var rootApis = "admision.tec.mx";

if(environment==="dev_server"){
  const hostDev = process.env.REACT_APP_HOST
  rootGestor = hostDev+"/";
  rootApis = hostDev;
}

const apiUrlGestor = protocolo + "//" + rootGestor + urlRoot + "/api/";
const apiUrlAced = protocolo + "//" + rootApis + "/aced/api/directory/";
const apiUrlAcedOdd = protocolo + "//" + rootApis + "/aced/api/odd/";
const apiUrlSaveSpot = "https://admision.tec.mx/savespot/api/";
const SaveSpotGuarda = "prod"; // prod o dev
const apiCoreSave = protocolo + "//" + rootApis + "/coresave/";
const apiODD = protocolo + "//" + rootApis + "/odd/";

export { apiUrlGestor, apiUrlAced, apiUrlAcedOdd, apiCoreSave, apiUrlSaveSpot, urlRoot, SaveSpotGuarda, urlRoute, eventRoot, apiODD }